export default __webpack_public_path__ + "static/media/no_image_available.b1f1e40c.png";